import { Pipe, PipeTransform } from '@angular/core';
import { CasualTournamentEntity } from '@fantaz/shared/data-access/models';

@Pipe({
  name: 'fzTournamentUrl',
  pure: true,
  standalone: true,
})
export class TournamentUrlPipe implements PipeTransform {
  transform(tournament: CasualTournamentEntity): string {
    return `/tournaments/${tournament.lifeExperience ? 'prizes' : 'cash'}/${
      tournament.url
    }/${tournament.eventSchedules[0].uuid}`;
  }
}
